import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import cls from 'clsx';
import { Button } from '@linktivity/link-ui';

import { TrainItemProps } from './TrainItem.types';

import styles from '../trainList.module.css';

const TrainItem = ({ train, isPreOrder, onBook }: TrainItemProps) => {
  const { t } = useTranslation();
  const seatAvailable = train?.ticketLeftCount && train.ticketLeftCount > 0;

  // format duration
  const formatDuration = useCallback(
    (minutes: number) => {
      const hours = Math.floor(minutes / 60);
      const mins = minutes % 60;

      if (mins > 0) {
        return t('views.trainList.durationFormat', { hours, minutes: mins });
      }
      return `${hours}${t('views.trainList.hour')}`;
    },
    [t]
  );

  return (
    <div className={styles.trainCard}>
      <div className={styles.trainInfo}>
        <div className={styles.trainTimeSection}>
          <div className={styles.trainTime}>{train.departTimeStr}</div>
          <div className={styles.trainStation}>{train.fromStationName}</div>
        </div>

        <div className={styles.trainMiddleSection}>
          <div className={styles.trainNumber}>{train.trainNumber}</div>
          <div className={styles.trainLine}>
            <div className={styles.trainLineBar} />
            <div className={styles.trainLineArrow} />
          </div>
          <div className={styles.trainDuration}>
            {train.durationMinutes ? formatDuration(train.durationMinutes) : ''}
          </div>
        </div>

        <div className={styles.trainTimeSection}>
          <div className={styles.trainTime}>{train.arriveTimeStr}</div>
          <div className={styles.trainStation}>{train.toStationName}</div>
        </div>
      </div>

      <div className={styles.trainFooter}>
        <div className={styles.seatInfo}>
          <span
            className={cls({
              [styles.seatAvailable]: seatAvailable && !isPreOrder,
              [styles.seatDisabled]: !seatAvailable && !isPreOrder,
              [styles.seatWarning]: isPreOrder
            })}
          >
            {isPreOrder
              ? t('views.trainList.notOnSale')
              : seatAvailable
                ? t('views.trainList.ticketsLeft', {
                    count: train.ticketLeftCount
                  })
                : t('views.trainList.noTickets')}
          </span>
        </div>
        <Button
          className={styles.bookButton}
          onClick={() => onBook(train)}
          disabled={!seatAvailable && !isPreOrder}
        >
          {isPreOrder
            ? t('views.trainList.preBook')
            : t('views.trainList.book')}
        </Button>
      </div>
    </div>
  );
};

export default TrainItem;
